import {
  IonToolbar,
  IonButtons,
  IonBackButton,
  isPlatform,
  IonTitle,
  IonButton,
  IonIcon,
  useIonAlert,
  useIonToast,
} from "@ionic/react";
import { trashOutline } from "ionicons/icons";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { deleteTemplate } from "../../../store/templateDetail/actions/deleteTemplate";
import { selectTemplateDetail } from "../../../store/templateDetail/selectors/selectTemplateDetail";
import { SubmitTemplateChangesButton } from "./SubmitTemplateChangesButton";

export const Toolbar = () => {
  const template = useSelector(selectTemplateDetail);
  const dispatch = useDispatch();

  const [presentToast, hideToast] = useIonToast();
  const [present] = useIonAlert();
  const history = useHistory();

  const handleDeleteTemplate = async () => {
    try {
      presentToast({
        message: `Eliminando plantilla...`,
        color: "primary",
      });
      const {
        payload: { success },
      }: any = await dispatch(deleteTemplate());
      if (!success) {
        throw new Error("No se envió la notificación");
      }
      await hideToast();
      presentToast({
        message: `Se elimino la plantilla.`,
        color: "success",
        duration: 8000,
      });
      return history.replace("/app/tic/plantillas");
    } catch (error) {
      await hideToast();
      presentToast({
        message: "Ocurrió un problema eliminando la plantilla.",
        color: "danger",
        duration: 8000,
      });
    }
  };
  return (
    <IonToolbar>
      <IonButtons slot="start">
        <IonBackButton
          text={isPlatform("ios") ? "Plantillas" : ""}
          defaultHref="/app/tic/plantillas"
          color="light"
        />
      </IonButtons>
      <IonButtons slot="end">
        <IonButton
          fill="solid"
          color="danger"
          onClick={() => {
            present({
              header: `¿Deseas eliminar esta plantilla?`,
              buttons: [
                "No",
                {
                  text: "Eliminar plantilla",
                  handler: () => handleDeleteTemplate(),
                },
              ],
            });
          }}
        >
          <IonIcon icon={trashOutline} />
        </IonButton>
        <SubmitTemplateChangesButton />
      </IonButtons>
      <IonTitle>{template.name}</IonTitle>
    </IonToolbar>
  );
};
